import type { ImagePreloaderProps } from '../types';

export function getSrcAttributes(imageSrc: ImagePreloaderProps['imageSrc']) {
  if (!Array.isArray(imageSrc)) {
    return { src: imageSrc };
  }

  const srcSet = imageSrc.reduce((acc, src, index) => {
    const icon = `${src} ${index + 1}x`;
    acc += index === 0 ? icon : `, ${icon}`;

    return acc;
  }, '');

  return { srcSet, src: imageSrc[0] };
}
